export const responsiveFontSizes = {
  64: { xs: '3rem', sm: '3.5rem', md: '4rem' },
  48: { xs: '2.5rem', sm: '2.75rem', md: '3rem' },
  40: { xs: '2rem', sm: '2.25rem', md: '2.5rem' },
  36: { xs: '1.75rem', sm: '2rem', md: '2.25rem' },
  32: { xs: '1.5rem', sm: '1.75rem', md: '2rem' },
  24: { xs: '1rem', sm: '1.25rem', md: '1.5rem' },
  20: { xs: '0.875rem', sm: '1rem', md: '1.25rem' },
  16: { xs: '0.875rem', sm: '1rem', md: '1rem' },
  14: { xs: '0.75rem', sm: '0.875rem', md: '0.875' },
  12: { xs: '0.625rem', sm: '0.75rem', md: '0.75rem' }
};
